import React from 'react';
import { Music, Headphones, Disc3 } from 'lucide-react';

const Header = () => {
  return (
    <>
      {/* Hero Section with Background Image */}
      <section style={{
        position: 'relative',
        minHeight: '100vh',
        height: 'auto',
        background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)), url('https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'scroll',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: '40px 0'
      }}>
        {/* Animated particles */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: `
            radial-gradient(circle at 20% 20%, rgba(102, 126, 234, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(255, 107, 107, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 60%, rgba(0, 242, 254, 0.05) 0%, transparent 50%)
          `,
          animation: 'backgroundShift 15s ease-in-out infinite'
        }} />
        
        <div className="container" style={{ 
          textAlign: 'center', 
          position: 'relative',
          zIndex: 2
        }}>
          {/* Floating music icons - hidden on mobile */}
          <div className="floating-icon" style={{
            position: 'absolute',
            top: '-50px',
            left: '10%',
            animation: 'musicNote 4s ease-in-out infinite'
          }}>
            <Music size={40} color="rgba(102, 126, 234, 0.3)" className="music-animation" />
          </div>
          <div className="floating-icon" style={{
            position: 'absolute',
            top: '-30px',
            right: '15%',
            animation: 'musicNote 3s ease-in-out infinite 1s'
          }}>
            <Headphones size={35} color="rgba(255, 107, 107, 0.3)" className="music-animation" />
          </div>
          <div className="floating-icon" style={{
            position: 'absolute',
            bottom: '-40px',
            left: '20%',
            animation: 'musicNote 5s ease-in-out infinite 2s'
          }}>
            <Disc3 size={45} color="rgba(0, 242, 254, 0.3)" className="music-animation" />
          </div>
          
          {/* Main title */}
          <h1 style={{
            fontSize: 'clamp(3rem, 8vw, 6rem)',
            fontWeight: '900',
            marginBottom: '24px',
            background: 'var(--primary-gradient)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: '0 0 40px rgba(102, 126, 234, 0.3)',
            animation: 'titleGlow 3s ease-in-out infinite'
          }}>
            Den Soniske Spalte
          </h1>
          
          {/* SEO Optimized Subtitle */}
          <p style={{
            fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
            color: 'var(--text-secondary)',
            marginBottom: '32px',
            fontWeight: '300',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          }}>
            Koncert Anmeldelser & Musik Anmeldelser
          </p>
          
          {/* Author introduction */}
          <div className="hero-content" style={{
            background: 'rgba(26, 26, 26, 0.8)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            padding: '40px',
            maxWidth: '800px',
            margin: '0 auto',
            border: '1px solid rgba(102, 126, 234, 0.2)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '2px',
              background: 'var(--secondary-gradient)'
            }} />
            
            <h2 style={{
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '20px',
              color: 'var(--text-primary)'
            }}>
              Velkommen til min musikalske verden
            </h2>
            
            <p style={{
              fontSize: '1.1rem',
              lineHeight: '1.8',
              color: 'var(--text-secondary)',
              marginBottom: '24px'
            }}>
              Jeg er <strong style={{ 
                color: 'var(--text-primary)',
                background: 'var(--primary-gradient)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Lasse Schütt Christensen</strong>, professionel musikanmelder og koncertanmelder. 
              Her finder du dybdegående <strong>musik anmeldelser</strong> af både nye og klassiske albums, 
              samt detaljerede <strong>koncert anmeldelser</strong> fra live oplevelser.
            </p>
            
            <p style={{
              fontSize: '1rem',
              color: 'var(--text-muted)',
              fontStyle: 'italic'
            }}>
              Fra indie rock til elektronisk musik - jeg leverer ærlige og indsigtsfulde  
              <strong>musikanmeldelser</strong> og <strong>koncertanmeldelser</strong> der hjælper dig med at opdage ny musik.
            </p>
          </div>
          
        </div>
      </section>
      
      <style jsx>{`
        @keyframes titleGlow {
          0%, 100% { filter: drop-shadow(0 0 20px rgba(102, 126, 234, 0.3)); }
          50% { filter: drop-shadow(0 0 40px rgba(102, 126, 234, 0.6)); }
        }
        
        @media (max-width: 768px) {
          .floating-icon {
            display: none !important;
          }
          
          .hero-content {
            padding: 24px !important;
            border-radius: 16px !important;
            margin: 0 16px !important;
          }
        }
        
        @media (max-width: 480px) {
          .hero-content {
            padding: 20px !important;
            border-radius: 12px !important;
            margin: 0 12px !important;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
